<template>
  <div class="goods-404">
    商品不存在：{{goodsId}}
  </div>
</template>

<script>
  export default {
    components: {
      
    },
    data() {
      return {

      }
    },
    mounted() {},
    props: ['goodsId'],
    computed: {
      
    },
    methods: {

    }
  }
</script>
